import alt from '../alt';
import LPListingsActions from './lp_listings_actions';

class LPListingsStore {
  constructor() {
    this.resetState();

    this.bindListeners({
      handleListingsLoaded: LPListingsActions.LP_LISTINGS_LOADED,
    });
  }

  handleListingsLoaded(listings) {
    this.lpListings = listings;
  }

  resetState() {
    this.lpListings = [];
  }
}

export default alt.createStore(LPListingsStore, 'LPListingsStore');



// WEBPACK FOOTER //
// ./javascripts/components/lp_listings/lp_listings_store.js